import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/common/Page";
import { api, errMsg } from "@/lib/api";
import { nullify, todayISO } from "@/lib/format";

export const AssessmentFormDialog = ({ open, onOpenChange, studentId, defaultSubject, onSaved }) => {
  const [form, setForm] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setForm({ subject: defaultSubject || "", content: "", score: "", date: todayISO(), notes: "" });
      setError("");
    }
  }, [open, defaultSubject]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/assessments", { ...nullify(form), content: form.content, score: Number(form.score), student_id: studentId });
      toast.success("Avaliação registrada");
      onSaved?.();
      onOpenChange(false);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="assessment-form-dialog">
        <DialogHeader><DialogTitle>Nova avaliação</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
          <Field label="Disciplina *"><Input value={form.subject || ""} onChange={set("subject")} required data-testid="assessment-subject-input" /></Field>
          <Field label="Conteúdo"><Input value={form.content || ""} onChange={set("content")} data-testid="assessment-content-input" /></Field>
          <Field label="Nota (0 a 10) *"><Input type="number" min="0" max="10" step="0.1" value={form.score ?? ""} onChange={set("score")} required data-testid="assessment-score-input" /></Field>
          <Field label="Data *"><Input type="date" value={form.date || ""} onChange={set("date")} required data-testid="assessment-date-input" /></Field>
          <Field label="Observações" className="sm:col-span-2"><Textarea value={form.notes || ""} onChange={set("notes")} rows={2} data-testid="assessment-notes-input" /></Field>
          {error && <p className="text-sm text-destructive sm:col-span-2" data-testid="assessment-form-error">{error}</p>}
          <DialogFooter className="sm:col-span-2">
            <Button type="submit" data-testid="assessment-form-submit">Salvar avaliação</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
